import log from 'minilog';
log.enable();

export default log('AntVideoController');